// extracted by mini-css-extract-plugin
module.exports = {"layout":"CorporatePage_layout__wBIbb","productsWidth":"CorporatePage_productsWidth__AdIo1","bottom":"CorporatePage_bottom__SBmf9","subtitle":"CorporatePage_subtitle__l5iNz"};